import {sendCustomMetric} from '@github-ui/stats'

export const applyRemoveChildPatch = () => {
  if (typeof Node === 'function' && Node.prototype) {
    const originalRemoveChild = Node.prototype.removeChild
    let hasReportedExternalDomMutation = false

    const reportExternalDomMutation = () => {
      if (hasReportedExternalDomMutation) return
      hasReportedExternalDomMutation = true

      try {
        sendCustomMetric({
          name: 'BROWSER_EXTERNAL_DOM_MUTATION_PREVENTED',
          value: 1,
          tags: {patch: 'remove_child'},
        })
      } catch {
        // Metrics must not interfere with DOM operations.
      }
    }

    // @ts-expect-error we always return a Node which is narrower than the function expects
    Node.prototype.removeChild = function (child) {
      if (child.parentNode !== this) {
        reportExternalDomMutation()
        return child
      }

      return originalRemoveChild.apply(this, [child])
    }
  }
}
